var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 48,
    viewBox: "0 0 176 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_37)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4729 22.7264V31.1824C65.8897 31.4054 64.6719 31.7227 62.4078 31.7227C56.8506 31.7227 53.2572 28.4209 53.2572 23.3096C53.2572 18.1983 56.9621 14.9651 62.708 14.9651C64.8777 14.9651 66.5672 15.2825 68.1795 16.0028L68.6855 16.2258L69.7489 12.8983L69.3544 12.7096C68.1795 12.1608 65.7525 11.5176 62.8109 11.5176C53.403 11.5176 49.115 17.6923 49.115 23.4211C49.115 26.7486 50.3499 29.8102 52.4939 31.817C54.8695 34.0468 58.0255 35.1359 62.1334 35.1359C65.7096 35.1359 68.6512 34.2612 70.0834 33.7381L70.4093 33.618V22.7264H66.4643H66.4729Z",
    fill: "#5A5B5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3643 34.9217H81.3521V11.7578H77.3643V34.9217Z",
    fill: "#5A5B5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9554 31.4141V11.7578H88.959V34.9217H103.512V31.4141H92.9554Z",
    fill: "#5A5B5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.509 31.4741V24.579H122.114V21.1314H112.509V15.2054H122.671V11.7578H108.512V34.9217H123.212V31.4741H112.509Z",
    fill: "#5A5B5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.329 11.7578H136.376L127.637 34.9217H131.668L134.232 27.8464H142.371L145.046 34.9217H149.154L140.321 11.7578H140.329ZM138.28 16.3117C138.503 17.0149 140.698 22.8552 141.35 24.5361H135.27C135.27 24.5361 138.065 17.0063 138.28 16.3117Z",
    fill: "#5A5B5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.872 14.8109C169.582 12.6583 166.023 11.5605 161.298 11.5605H153.845V14.8966L161.384 14.9138C164.848 14.9138 167.447 15.7542 169.102 17.4265C170.44 18.773 171.1 20.6168 171.083 22.9152C171.083 25.4623 170.285 27.5977 168.776 29.0985C167.018 30.848 164.274 31.7657 160.826 31.7571C159.78 31.7571 158.639 31.7399 157.807 31.6542V21.1657H153.845V34.8187L154.291 34.8616C156.024 35.0417 157.91 35.1189 160.312 35.1189C165.226 35.1189 169.273 33.8411 171.709 31.517C173.982 29.2872 175.225 26.1912 175.225 22.778C175.225 19.3647 174.102 16.8262 171.872 14.7937V14.8109Z",
    fill: "#5A5B5D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0793 0.12864C36.0793 0.0600322 36.0193 0 35.9507 0H35.9335C5.97749 2.84724 2.16116 23.5069 11.955 30.1018C10.2655 37.5544 11.8349 37.3829 11.8349 37.3829C12.1351 35.1617 12.581 32.9577 13.147 30.7879C16.972 16.2601 26.4227 3.5762 35.9593 0.265857C36.0279 0.257281 36.0793 0.197249 36.0793 0.12864Z",
    fill: "#D93748"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4928 4.87962C34.4928 4.80243 34.4327 4.75098 34.3641 4.75098C34.3041 4.75098 34.2612 4.78528 34.2355 4.83674C31.757 9.69077 31.0452 16.6373 29.1585 21.9545C26.9973 28.0349 23.1638 32.1342 17.2464 31.7483V46.5334C17.2464 46.5334 1.4322 39.381 1.4322 27.8719V6.32896L14.3563 5.14547C14.4334 5.14547 14.4935 5.08544 14.4935 5.00826C14.4935 4.93965 14.442 4.87962 14.3648 4.87962H0V27.8805C0 40.8217 17.2464 48.0084 17.2464 48.0084C17.2464 48.0084 34.5013 40.7017 34.5013 27.8805V4.87962H34.4928Z",
    fill: "#D93748"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175.217,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.04be982c0da178ce22b3455c0767960a.svg";
export { ForwardRef as ReactComponent };